import React, { useEffect, useRef, useState } from "react";
import { DASHBOARD_ORDER_URL } from "../../api/URLs";
import { getDataRequest } from "../../api/serviceMethods";
import { Spin } from "antd";
import MessageConfirmModal from "../../components/messageModal/MessageConfirmModal";
import DashboardProductPurchase from "../../components/dashboard/dashboardProductPurchase";
import TableProductPurchasePage from "./TableProductPurchasePage";

const ProductPurchasePage = () => {
  const messageModalRef = useRef("");
  const [dashboardPaymentData, setDashboardPaymentData] = useState(null);
  const [loading, setLoading] = useState(false);

  const getDashboard = async () => {
    try {
      setLoading(true);
      const res = await getDataRequest(`${DASHBOARD_ORDER_URL}`);
      if (res.status === 200) {
        setDashboardPaymentData(res.data);
      }
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getDashboard();
  }, [])

  return (
    <div className="box-shadow h-100 w-100">
      <div className="w-100 h-100 overflow-auto">
        <Spin spinning={loading}>
          <div className="w-100">
            <DashboardProductPurchase dashboardPaymentData={dashboardPaymentData} />
            <TableProductPurchasePage messageModalRef={messageModalRef} loading={loading} setLoading={setLoading} />
          </div>
        </Spin>
        <MessageConfirmModal textCentered ref={messageModalRef} />
      </div>
    </div>
  )
}

export default ProductPurchasePage